import React, { useMemo } from 'react';
import { Tooltip } from 'react-tooltip';
import { CloseButton, CloseButtonColor } from '../LiliCloseButton/CloseButton';

export enum TooltipPosition {
  TOP = 'top',
  TOP_START = 'top-start',
  TOP_END = 'top-end',
  BOTTOM = 'bottom',
  BOTTOM_START = 'bottom-start',
  BOTTOM_END = 'bottom-end',
  LEFT = 'left',
  LEFT_START = 'left-start',
  LEFT_END = 'left-end',
  RIGHT = 'right',
  RIGHT_START = 'right-start',
  RIGHT_END = 'right-end',
}

export enum LiliToolTipColor {
  White,
  Blue,
  Black,
}

export interface LiliToolTipProps {
  title?: string;
  description: string;
  showCloseButton?: boolean;
  targetId: string;
  color?: LiliToolTipColor;
  position?: TooltipPosition;
  isOpen?: boolean;
  onClose?: () => void;
  width?: string;
  customContent?: React.ReactNode;
}

export const LiliTooltip = ({
  title,
  description,
  showCloseButton,
  targetId,
  color = LiliToolTipColor.Black,
  position = TooltipPosition.BOTTOM,
  isOpen,
  onClose,
  width,
  customContent,
}: LiliToolTipProps) => {
  const backgroundColor = useMemo(() => {
    let colorClass: string;
    switch (color) {
      case LiliToolTipColor.White:
        colorClass = '#ffffff';
        break;
      case LiliToolTipColor.Black:
        colorClass = '#20242E';
        break;
      case LiliToolTipColor.Blue:
        colorClass = '#0E5CF4';
        break;
      default:
        colorClass = '#ffffff';
    }
    return colorClass;
  }, [color]);
  const textColor = () => {
    switch (color) {
      case LiliToolTipColor.White:
        return 'text-bw07';
      case LiliToolTipColor.Black:
        return 'text-bw00';
      case LiliToolTipColor.Blue:
        return 'text-bw00';
      default:
        return 'text-bw00';
    }
  };

  const closeButtonColor = () => {
    switch (color) {
      case LiliToolTipColor.White:
        return CloseButtonColor.Gray;
      case LiliToolTipColor.Black:
        return CloseButtonColor.White;
      case LiliToolTipColor.Blue:
        return CloseButtonColor.White;
      default:
        return CloseButtonColor.Gray;
    }
  };
  const tooltipStyle = `z-[999] !p-0 !opacity-100 max-w-[${width || '290px'}]`;
  return (
    <Tooltip
      id={targetId}
      className={tooltipStyle}
      border={color === LiliToolTipColor.White ? '1px solid #DFE2EB' : ''}
      place={position}
      isOpen={isOpen === undefined ? undefined : isOpen}
      style={{ backgroundColor }}
      hidden={isOpen !== undefined && !isOpen}
      clickable
    >
      <div className='flex flex-row '>
        {customContent || (
          <div className='flex flex-col px-[16px] py-[12px] h-fit'>
            <p className={`text-[16px] font-metricRMedium ${textColor()}`}>{title}</p>
            <p className={`text-[16px] font-metricR ${textColor()}`}>{description}</p>
          </div>
        )}
        {showCloseButton && (
          <CloseButton
            id={`${targetId}-close-button`}
            color={closeButtonColor()}
            onClick={onClose}
            className='pt-[8px] pr-[12px]'
          />
        )}
      </div>
    </Tooltip>
  );
};
